<div class="toggle-switch-container" (click)="onToggle()">
  <div class="toggle-switch" [class.checked]="isChecked">
    <div class="toggle-switch-handle"></div>
  </div>
  <span class="toggle-switch-label">{{ label }}</span>
</div>
